import {
	SitePartSupplierEditApi,
	SitePartSupplierEditApi_InitData,
} from "src/api/generated/erp/parts/sitePart/api/sitePartSupplierEditApi";
import { AsyncForm, AsyncFormContentParams } from "src/components/common/forms/AsyncForm.tsx";
import { FormCommonProps } from "src/components/common/forms/types.ts";
import {
	SitePartSupplierFormContent,
	SitePartSupplierFormValues,
} from "src/components/views/erp/parts/siteParts/SitePartSupplierFormContent.tsx";
import { DeepPartial } from "react-hook-form";
import { SupplierPart } from "src/api/generated/erp/db/types/tables/supplierPart.ts";
import { defineAgentUiContextKey } from "src/components/views/ai/assistant/uiContext/agentUiContextKey.ts";

export interface SitePartSupplierFormProps extends FormCommonProps<number> {
	partId: number;
	supplierPartId?: number;
}

export const SitePartSupplierForm = ({
	partId,
	supplierPartId,
	onCompleted,
	onFormEdited,
}: SitePartSupplierFormProps) => {
	return (
		<AsyncForm<SitePartSupplierEditApi_InitData, SitePartSupplierFormValues, number>
			columns={2}
			fetch={() =>
				SitePartSupplierEditApi.getInitData({
					partId: partId,
					supplierPartId: supplierPartId,
				})
			}
			getDefaultValues={getDefaultValues}
			onCompleted={onCompleted}
			onFormEdited={onFormEdited}
			agentContext={{
				key: defineAgentUiContextKey("erp.parts.sitePartSupplier.form"),
				data: {
					partId,
					supplierPartId: supplierPartId ?? null,
				},
			}}
			render={({ data, ...formContentParams }) => (
				<SitePartSupplierFormContent
					{...formContentParams}
					partId={partId}
					supplierPartId={supplierPartId}
					erpUnitOptions={data.erpUnitOptions}
				/>
			)}
			submit={submit}
		/>
	);

	function getDefaultValues(initData: SitePartSupplierEditApi_InitData): DeepPartial<SitePartSupplierFormValues> {
		const part = initData.part;
		return initData.supplierPart != null ?
				initData.supplierPart
			:	{
					purchaseUnitId: part.partUnitId,
					purchaseFactor: 1,
					purchasePriceUnitId: part.partUnitId,
					purchasePriceFactor: 1,
					packSize: 1,
					isDefault: false,
					deliveryDuration: 1,
				};
	}

	async function submit(
		formValues: SitePartSupplierFormValues,
		{
			data: { supplierPart: existingSupplierPart },
		}: AsyncFormContentParams<SitePartSupplierEditApi_InitData, SitePartSupplierFormValues>,
	) {
		const toSave: Partial<SupplierPart> = {
			partId: partId,
			supplierPartId: supplierPartId,
			lastUpdated: existingSupplierPart?.lastUpdated,
			...formValues,
		};
		return await SitePartSupplierEditApi.save({
			supplierPart: toSave as SupplierPart,
		});
	}
};
